<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><a class="page" id="piii"></a>SEX, DEATH &amp; MINUETS</h1>
<h1 class="bk1">Anna Magdalena Bach and Her Musical Notebooks</h1>
<h1 class="bk1"><img alt="" height="10" src="images/Fermata.jpg" width="17"/></h1>
<p class="bkau">DAVID YEARSLEY</p>
<p class="bkpub">THE UNIVERSITY OF CHICAGO PRESS</p>
<p class="bkpub1">CHICAGO AND LONDON</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-yearsley-0004.vue?eece8ce2